<template>
  <header class="header">
    <div class="container">
      <div class="header__inner">
        <a href="/" class="header__logo">
          <img
            src="~/assets/img/main/logo--mts.svg"
            alt="Webinar"
            class="header__logo_img"
            width="104"
            height="40"
          />
        </a>
        <HeaderMenuListDesktop
          :class="['header__menu-list']"
          @openMenu="$emit('openMenu')"
          @closeMenu="$emit('closeMenu')"
        />
        <div class="header__btn-list">
          <VButtonLinkMTSV2
            href="/faq_and_support"
            class="header__btn --support --grey --m"
          >
            <VIconMTS
              :name="'mts/icon-mts--support-fill'"
              :width="24"
              :height="24"
              fill="#1D2023"
              class="header__btn-icon"
            />
            <span>Поддержка 24/7</span>
          </VButtonLinkMTSV2>

          <VButtonLinkMTSV2
            href="tel:74951184444"
            class="header__btn --phone --grey --m"
          >
            <VIconMTS
              :name="'mts/icon-mts--phone-empty'"
              :width="24"
              :height="24"
              fill="#1D2023"
              class="header__btn-icon"
            />
            <!-- <span>8 800 551 04 69</span> -->
          </VButtonLinkMTSV2>

          <VButtonLinkMTSV2
            href="javascript:void(0);"
            class="header__btn --signin --grey --m"
            @click="sendMetricsSigninClient"
          >
            <span>Войти</span>
          </VButtonLinkMTSV2>

          <VButtonMTSV2
            class="header__btn --burger"
            data-toggle="slideout-button"
            aria-label="Aria Open menu"
            @click="$emit('openSidebar')"
          >
            <VIconMTS
              :name="'mts/icon-mts--menu'"
              :width="24"
              :height="24"
              fill="#1D2023"
              class="header__btn-icon"
            />
          </VButtonMTSV2>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import HeaderMixin from '~/components/Desktop/Header/mixins/HeaderMixin'
import VButtonLinkMTSV2 from '~/components/Common/MTS/VButtonLinkMTSV2.vue'
import VButtonMTSV2 from '~/components/Common/MTS/VButtonMTSV2.vue'
import HeaderMenuListDesktop from '@/components/Desktop/Header/HeaderMenuListDesktop.vue'
import VIconMTS from '~/components/Common//MTS/VIconMTS.vue'

export default {
  name: 'HeaderDesktop',
  components: {
    HeaderMenuListDesktop,
    VIconMTS,
    VButtonLinkMTSV2,
    VButtonMTSV2,
  },
  mixins: [HeaderMixin],
}
</script>

<style lang="scss" scoped>
.header {
  font-family: $font-mts-compact;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  position: relative;
  z-index: 450;
  background: #fff;
  padding: 14px 0;
  color: $color-dark-2;

  .container {
    max-width: 1440px;
    padding-left: 32px;
    padding-right: 32px;
  }

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 44px;
    position: relative;
  }

  &__btn {
    $btn: &;
    @include screen-up('lg') {
      flex: 0 auto;
    }

    &-list {
      display: flex;
      column-gap: 16px;
      justify-content: flex-end;
    }
    &-icon {
      flex: 1 24px;
    }

    &.--burger {
      padding: 0;
      @include screen-up('xl') {
        display: none;
      }
    }
    &.--support {
      #{$btn}-icon {
        @include screen-up('xl') {
          display: none;
        }
      }
    }
    &.--support,
    &.--phone {
      display: flex;
      align-items: center;
      span {
        @include screen-down('xl') {
          display: none;
        }
      }
    }
  }

  &__menu-list {
    flex: 1;
    justify-self: flex-start;
  }
}
</style>
